module.exports = __webpack_public_path__ + "static/media/icono-flecha-roja.5f323616.svg";